import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { PackageDetailsSummary } from '../../../types';
import { TableRow } from '../Shared/Tables'


interface PackageRowProps {
    children: ReactNode;
    packageSummary: PackageDetailsSummary;
    handleClick(somePackage: PackageDetailsSummary);
};

const PackageRowComponent = React.forwardRef(({ children, packageSummary, handleClick }: PackageRowProps, ref) => {
    return (
        <TableRow
            className={'interactive'}
            index={packageSummary.TrackingReference}
            onClick={() => handleClick(packageSummary)}
        >
            {children}
        </TableRow>
    );
});

export default PackageRowComponent;